import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import fr from './locales/fr.json';

// Récupérer la langue depuis localStorage, ou utiliser 'en' par défaut
const storedLocale = localStorage.getItem('locale') || 'en';

const i18n = createI18n({
  locale: storedLocale, // Langue par défaut
  messages: {
    en,
    fr,
  },
});

export default i18n;
